import { graphql } from "../gql";

export const getDrgClaimStatusesQueryDoc = graphql(`
  query drgClaimStatuses($claimIds: [ID!]!) {
    drgClaimStatuses(claimIds: $claimIds) {
      claimId
      drgStatus
    }
  }
`);
